export const vegetablesWithBlackSauce = {
  id: "vegetablesWithBlackSauce",
  link: "/#/recipes/recipes/vegetablesWithBlackSauce",
  name: "Vegetables with Black Sauce",
  cuisine: "Alethi",
  summary: "Steamed vegetables with salty fruit sauce",
  inspiration: null,
  quantity: "6 servings",
  time: "20 minutes",
  notes:
    "This is one of the dishes that Kaladin ate while imprisoned. I decided early on when making these recipes not to use soy sauce. It seems the obvious answer here - salty black sauce. But not using soy sauce felt like a good way to make Rosharan food feel a little more alien. It turns out that there are relatively few other ways to make a truly black sauce, though. I experimented with a few options and like the prune sauce the best. I will not judge you if you just decide to steam the vegetables and top with your favorite soy-based sauce, though (soy sauce, teriyaki, hoisin, etc).",
  quotes:
    "Kaladin sighed, retrieving the food - steamed vegetables, dribbled with a salty black sauce - and flopping back on his bench. (Words of Radiance ch 59)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/vegetables-with-black-sauce-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "plum",
          display: "1/2 cup finely chopped prunes"
        },
        {
          item: "fishSauce",
          display: "2 tbsp fish sauce"
        },
        {
          item: "sesame",
          display: "1 tsp sesame oil"
        },
        {
          item: "ginger",
          display: "1/2 inch ginger"
        },
        {
          item: "water",
          display: "1 cup water, plus additional"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "summerSquash",
          display: "1 yellow squash"
        },
        {
          item: "bellPepper",
          display: "2 bell peppers, any color"
        },
        {
          item: "onion",
          display: "1 onion"
        }
      ]
    }
  ],
  steps: [
    "Peel and grate the ginger. Finely chop the prunes and measure 1/2 cup lightly packed. Add prunes, fish sauce, sesame oil, ginger and 1 cup water to a pot. Bring to a boil over medium high heat, then reduce heat and simmer 10 minutes.",
    "Peel the onion. Chop the squash, bell peppers, and onion to bite sized pieces. Steam 8 minutes or until vegetables are tender.",
    "Once the prune mixture is done simmering, blend it with an immersion blender until mostly smooth. Add 1/2 tsp salt and enough water (about 1/4 cup) to form a thick yet pourable sauce. Pour sauce over vegetables to serve."
  ]
}
